import {
  Box, Typography, Chip, Divider, Tooltip, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, useTheme,
} from '@mui/material';

const UserSearchesTab = ({ searches }) => {
  const theme = useTheme();

  return (
    <Box>
      {/* Search Queries */}
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
        Search Queries ({searches?.total || 0})
      </Typography>
      {searches?.items?.length > 0 ? (
        <TableContainer sx={{ borderRadius: '8px', border: `1px solid ${theme.palette.divider}`, mb: 3 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
                <TableCell sx={{ fontWeight: 600 }}>Query</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Mode</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Language</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searches.items.map((s, i) => (
                <TableRow key={s.id || i}>
                  <TableCell>
                    <Tooltip title={s.title} placement="top-start" arrow>
                      <Typography variant="body2" sx={{ maxWidth: 400 }} noWrap>{s.title}</Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    {s.mode && <Chip label={s.mode} size="small" sx={{ fontSize: '0.7rem' }} />}
                  </TableCell>
                  <TableCell><Typography variant="body2">{s.pref_language || '—'}</Typography></TableCell>
                  <TableCell>
                    <Typography variant="body2">{s.created_at ? new Date(s.created_at).toLocaleString() : '—'}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>No searches recorded.</Typography>
      )}

      {/* Saved Searches */}
      {searches?.saved_searches?.length > 0 && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
            Saved Searches ({searches.saved_searches.length})
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {searches.saved_searches.map((s) => (
              <Chip
                key={s.id}
                label={`${s.name || s.query} (${s.mode})`}
                size="small"
                variant="outlined"
              />
            ))}
          </Box>
        </>
      )}

      {/* Bookmarks */}
      {searches?.bookmarks?.length > 0 && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
            Bookmarks ({searches.bookmarks.length})
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {searches.bookmarks.map((b) => (
              <Chip
                key={b.id}
                label={`${b.document_type}: ${b.document_external_id}`}
                size="small"
                variant="outlined"
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default UserSearchesTab;
